import { Box } from '@mui/material';
import { Button, PasswordInput, PasswordRequirements } from 'components/ui';
import { CompleteSignUpFormData, completeSignUpFormSchema } from 'forms';
import { mutateProfile, useAppForm } from 'hooks';
import React, { ReactElement } from 'react';
import { useAuthApi } from 'services/api';

export interface CompleteSignUpFormProps {
  token: string;
  onSubmit: () => void;
}

export const CompleteSignUpForm = ({
  token,
  onSubmit: onSubmitProp,
}: CompleteSignUpFormProps): ReactElement => {
  const {
    register,
    handleSubmit,
    formState: { errors, dirtyFields, isSubmitting },
  } = useAppForm(completeSignUpFormSchema, {
    mode: 'all',
  });

  const authApi = useAuthApi();

  const onSubmit = async (data: CompleteSignUpFormData) => {
    await authApi.completeSignUp({ ...data, token });
    void mutateProfile();
    onSubmitProp?.();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box mt={30}>
        <PasswordInput label="Password" {...register('password')} />
        <PasswordRequirements
          errors={Object.values(errors.password?.types ?? {}) as string[]}
          dirty={!!dirtyFields.password}
        />
      </Box>

      <Box mt={30}>
        <Button
          type="submit"
          minWidth="100%"
          variant="vibrant"
          minHeight={47}
          disabled={isSubmitting}
        >
          Save &amp; Continue
        </Button>
      </Box>
    </form>
  );
};
